"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLocalDatabaseRowShardDocId = exports.isLocalDatabaseRootDocId = exports.extractDatabaseIdFromRootDocId = exports.databaseDocumentCollectionRoot = exports.createServerPagePartDocIdPrefix = exports.createServerPagePartDocId = exports.createServerDatabaseRowShardDocIdPrefix = exports.createServerDatabaseRowShardDocId = exports.createServerDatabaseRootDocId = exports.createServerDatabaseDocIdPrefix = exports.createServerDatabaseDirectoryPartDocIdPrefix = exports.createServerDatabaseDirectoryPartDocId = exports.createLocalDatabaseRootDocId = exports.collectDatabaseStorageSyncDocIds = exports.matchesDatabaseViewFilter = exports.isOlderThanDays = exports.getDatabaseViewFilterFunction = exports.databaseViewFilterFunctions = exports.databaseAttachmentFilterFunctions = exports.prepareDatabaseProjectionPredicate = exports.parseDatabaseProjectionDate = exports.normalizeDatabaseProjectionWindow = exports.matchesDatabaseProjectionPredicate = exports.isEmptyDatabaseProjectionValue = exports.createDatabaseProjectionAggregate = exports.calculateDatabaseProjectionAggregate = exports.normalizeDatabaseSearchQuery = exports.matchesDatabaseSearchText = exports.matchesDatabaseRowSearch = exports.databaseSearchCellText = exports.forwardDocumentUpdate = exports.forwardDocumentToState = exports.planDatabaseRowShardMerges = exports.planDatabaseRowOrderSplices = exports.planDatabaseRowOrderChange = exports.planDatabaseRowInsertion = exports.partitionDatabaseRowShardRows = exports.nextDatabaseShardIndex = exports.nextDatabaseRowShardIndex = exports.fitDatabaseRowShardPrefix = exports.databaseRowShardId = exports.databaseDirectoryShardIndexHolds = exports.canonicalDatabaseRowOrder = exports.cloneDatabaseColumns = exports.validateCleanupTimezone = exports.validateCleanupPolicy = exports.resolveCleanupBinding = exports.readCleanupRunResult = exports.CleanupPolicyValidationError = exports.cleanupBindingConfiguration = void 0;
exports.TABLE_DEFAULT_HIDDEN_PROPERTY_TYPES = exports.orderCanonicalKanbanProperties = exports.KANBAN_SYSTEM_BODY_PROPERTY_TYPES = exports.KANBAN_L2_GROUPABLE_PROPERTY_TYPES = exports.KANBAN_L2_GROUP_MATCHER_NAMES = exports.KANBAN_DEFAULT_VISIBLE_SYSTEM_BODY_PROPERTY_TYPES = exports.KANBAN_DEFAULT_VISIBLE_BODY_PROPERTY_COUNT = exports.isCanonicalTablePropertyVisible = exports.isCanonicalKanbanL2PropertyShape = exports.getCanonicalKanbanVisiblePropertyIds = exports.DATABASE_VIEW_MODES = exports.createCanonicalTableViewData = exports.createCanonicalKanbanViewData = exports.createCanonicalGanttViewData = exports.createCanonicalCalendarViewData = exports.isDatabaseTrashBlocked = exports.resolveDatabaseCellStorageKeyFromHas = exports.resolveDatabaseCellStorageKey = exports.DOCUMENT_PRODUCT_HARD_LIMIT_BYTES = exports.DATABASE_LARGE_DATA_POLICY = exports.isCatalogImage = exports.findFreeCanvasRowRects = exports.findFreeCanvasRect = exports.DEFAULT_CANVAS_PLACEMENT_GAP = exports.createRightSideBranchCandidates = exports.estimateCanvasDatabaseLiveTableHeight = exports.DATABASE_TABLE_STATS_BAR_HEIGHT = exports.DATABASE_TABLE_ROW_HEIGHT = exports.DATABASE_TABLE_ROW_GUTTER_WIDTH = exports.DATABASE_TABLE_HEADER_HEIGHT = exports.DATABASE_TABLE_ADD_COLUMN_WIDTH = exports.CANVAS_DATABASE_TABLE_GROUP_FOOTER_HEIGHT = exports.CANVAS_DATABASE_ROW_WINDOW_FOOTER_HEIGHT = exports.CANVAS_DATABASE_PRESENTATION_HEADER_HEIGHT = exports.CANVAS_DATABASE_PADDING_X = exports.CANVAS_DATABASE_LIVE_CHROME_HEIGHT = exports.CALENDAR_MAX_VISIBLE_SOURCES = exports.SERVER_DATABASE_ROOT_DOC_ID_LIKE_PATTERN = exports.parseServerPagePartDocId = exports.parseServerDatabaseRowShardDocId = exports.parseServerDatabaseRootDocId = exports.parseServerDatabaseDocId = exports.parseServerDatabaseDirectoryPartDocId = exports.parseLocalDatabaseRowShardDocId = exports.parseLocalDatabaseRootDocId = exports.normalizeDatabaseBlockId = exports.isServerPagePartDocId = exports.isServerDatabaseRowShardDocId = exports.isServerDatabaseRootDocId = exports.isServerDatabaseDirectoryPartDocId = void 0;
exports.DEFAULT_CANVAS_DATABASE_WIDTH = exports.ViewBackedAppResourceIdError = exports.viewBackedAppResourceId = exports.parseViewBackedAppResourceId = exports.takeTrashCanvasMembers = exports.restoreTrashCanvasMembers = exports.restorableTrashConnectors = exports.leaveCanvasGroup = exports.findCanvasSurfaceElements = exports.collectAttachedCanvasConnectorIds = exports.temporalProfileRoleColumnId = exports.temporalProfileRoleAcceptsPropertyType = exports.TEMPORAL_PROFILE_VIEW_TYPES = exports.TEMPORAL_PROFILE_ROLES = exports.TEMPORAL_PROFILE_ROLE_PRIMARY_TYPE = exports.TEMPORAL_PROFILE_ROLE_FIELDS = exports.resolveTemporalProfileColumn = exports.resolveTemporalDateColumns = exports.isTemporalProfileViewType = exports.VIEW_CONFIG_MANAGED_BY = exports.resolveAppBaseStandardDatabaseRole = exports.isUserFacingAppBaseStandardDatabaseRole = exports.isHiddenSystemManagedDatabase = exports.APP_BASE_STANDARD_USER_FACING_DATABASE_ROLES = exports.APP_BASE_STANDARD_DATABASE_MANAGED_BY_PREFIX = exports.statusTrackingRowStates = exports.statusTrackingOptionLookup = exports.statusTrackingCellState = exports.isStatusTrackingRowOpen = exports.isStatusTrackingPredicateConfigured = exports.filterRowsByStatusTracking = exports.historySnapshotWindowStartMs = exports.historySnapshotWindowIndex = exports.HISTORY_SNAPSHOT_INTERVAL_SECONDS = exports.HISTORY_SNAPSHOT_INTERVAL_MS = exports.normalizeAttachmentCell = exports.isFileIndexSystemColumnId = exports.isFileIndexManagedColumnData = exports.isFileIndexDatabaseId = exports.FILE_INDEX_SOURCE_HIGHLIGHT_CLASS = exports.FILE_INDEX_ROW_ID_PREFIX = exports.FILE_INDEX_ROW_HIGHLIGHT_ATTRIBUTE = exports.FILE_INDEX_MANAGED_BY = exports.FILE_INDEX_HIGHLIGHT_SCOPES = exports.FILE_INDEX_HIGHLIGHT_EVENTS = exports.FILE_INDEX_DATABASE_PROTECTION_PROPS = exports.FILE_INDEX_DATABASE_ID_PREFIX = exports.FILE_INDEX_COLUMNS = exports.FILE_INDEX_COLUMN_IDS = exports.decodeFileIndexRowSourceBlockId = void 0;
exports.pageStructureAncestors = exports.pagePartsMayHoldId = exports.computeRollupValue = exports.DATABASE_IMPORT_INLINE_ESTIMATED_BYTE_HARD_LIMIT = exports.DATABASE_IMPORT_INLINE_ESTIMATED_BYTE_WARNING_THRESHOLD = exports.DATABASE_ROW_SHARD_HARD_LIMIT_BYTES = exports.DATABASE_ROW_SHARD_TARGET_BYTES = exports.DATABASE_COLUMN_HARD_LIMIT = exports.ROOT_DOC_ROW_MATERIALIZATION_HARD_LIMIT = exports.DATABASE_ROW_SYSTEM_FIELD_NAMES = exports.DATABASE_ROW_SYSTEM_FIELD_IDS = exports.DATABASE_ROW_UPDATED_BY_FIELD_ID = exports.DATABASE_ROW_UPDATED_TIME_FIELD_ID = exports.DATABASE_ROW_CREATED_BY_FIELD_ID = exports.DATABASE_ROW_CREATED_TIME_FIELD_ID = exports.ROW_SHARDED_DATABASE_GATE_MESSAGE = exports.INVALID_DATABASE_STORAGE_MESSAGE = exports.SELECT_OPTION_COLOR_BY_NAME = exports.SELECT_OPTION_COLOR_VALUES = exports.SELECT_OPTION_COLORS = exports.CANVAS_DATABASE_LAYOUT_ROW_STEP = exports.CANVAS_DATABASE_LAYOUT_COLUMN_STEP = exports.CANVAS_DATABASE_LAYOUT_PAGE_NODE_RESERVED_HEIGHT = exports.CANVAS_DATABASE_LAYOUT_ROW_GAP = exports.CANVAS_DATABASE_LAYOUT_COLUMN_GAP = exports.CANVAS_DATABASE_LAYOUT_NODE_HEIGHT = exports.CANVAS_DATABASE_LAYOUT_NODE_WIDTH = exports.MAX_CANVAS_DATABASE_HEIGHT = exports.MIN_CANVAS_DATABASE_HEIGHT = exports.DEFAULT_CANVAS_DATABASE_HEIGHT = void 0;
exports.createCanvasDatabaseLayout = createCanvasDatabaseLayout;
exports.createCanvasDatabaseGridLayout = createCanvasDatabaseGridLayout;
exports.canvasDatabaseGeometry = canvasDatabaseGeometry;
exports.serializeCanvasDatabaseXYWH = serializeCanvasDatabaseXYWH;
exports.getRandomSelectOptionColor = getRandomSelectOptionColor;
exports.createSelectOptionColorPicker = createSelectOptionColorPicker;
exports.isDatabaseRowSystemFieldId = isDatabaseRowSystemFieldId;
exports.createDatabaseRowCreationSystemFieldCells = createDatabaseRowCreationSystemFieldCells;
exports.createDatabaseRowUpdateSystemFieldCells = createDatabaseRowUpdateSystemFieldCells;
exports.toDatabaseRowStoredCell = toDatabaseRowStoredCell;
exports.readDatabaseRowStoredCell = readDatabaseRowStoredCell;
exports.readDatabaseRowStoredCellValue = readDatabaseRowStoredCellValue;
exports.readDatabaseRowCreatedAt = readDatabaseRowCreatedAt;
exports.isDatabaseRowSystemFieldCell = isDatabaseRowSystemFieldCell;
exports.assertDatabaseWriteShapeWithinLimits = assertDatabaseWriteShapeWithinLimits;
exports.assertDatabaseColumnShapeWithinLimits = assertDatabaseColumnShapeWithinLimits;
exports.estimateDatabaseImportPreflight = estimateDatabaseImportPreflight;
exports.assertDatabaseImportPreflightAllowsInlineShardedMutation = assertDatabaseImportPreflightAllowsInlineShardedMutation;
exports.assertDatabaseImportPreflightAllowsShardedMutation = assertDatabaseImportPreflightAllowsShardedMutation;
exports.isValidDatabaseBlockId = isValidDatabaseBlockId;
exports.normalizeDatabaseShardManifest = normalizeDatabaseShardManifest;
exports.normalizeDatabaseShardManifestEntry = normalizeDatabaseShardManifestEntry;
exports.planDatabaseShardRowWindow = planDatabaseShardRowWindow;
exports.assertDatabaseRowShardBytesWithinLimits = assertDatabaseRowShardBytesWithinLimits;
exports.createShardedDatabaseIdentityProps = createShardedDatabaseIdentityProps;
exports.createDatabaseReferenceProps = createDatabaseReferenceProps;
exports.writeSerializedShardedDatabaseIdentity = writeSerializedShardedDatabaseIdentity;
exports.writeSerializedDatabaseReference = writeSerializedDatabaseReference;
exports.resolveDatabaseIdentity = resolveDatabaseIdentity;
exports.assertDatabaseIdentity = assertDatabaseIdentity;
exports.createDatabaseShardManifestEntry = createDatabaseShardManifestEntry;
exports.createDatabaseShardManifest = createDatabaseShardManifest;
exports.assertDatabaseShardManifest = assertDatabaseShardManifest;
exports.databaseShardMayContainProbe = databaseShardMayContainProbe;
exports.databaseShardMayContainRow = databaseShardMayContainRow;
exports.selectDatabaseShardsMayContainRow = selectDatabaseShardsMayContainRow;
exports.databaseShardsMayContainRow = databaseShardsMayContainRow;
exports.selectDatabaseShardsMayContainRows = selectDatabaseShardsMayContainRows;
exports.selectDatabaseRowShardsByIds = selectDatabaseRowShardsByIds;
var database_cleanup_1 = require("./database-cleanup");
Object.defineProperty(exports, "cleanupBindingConfiguration", { enumerable: true, get: function () { return database_cleanup_1.cleanupBindingConfiguration; } });
Object.defineProperty(exports, "CleanupPolicyValidationError", { enumerable: true, get: function () { return database_cleanup_1.CleanupPolicyValidationError; } });
Object.defineProperty(exports, "readCleanupRunResult", { enumerable: true, get: function () { return database_cleanup_1.readCleanupRunResult; } });
Object.defineProperty(exports, "resolveCleanupBinding", { enumerable: true, get: function () { return database_cleanup_1.resolveCleanupBinding; } });
Object.defineProperty(exports, "validateCleanupPolicy", { enumerable: true, get: function () { return database_cleanup_1.validateCleanupPolicy; } });
Object.defineProperty(exports, "validateCleanupTimezone", { enumerable: true, get: function () { return database_cleanup_1.validateCleanupTimezone; } });
var database_clone_js_1 = require("./database-clone.js");
Object.defineProperty(exports, "cloneDatabaseColumns", { enumerable: true, get: function () { return database_clone_js_1.cloneDatabaseColumns; } });
__exportStar(require("./database-projection"), exports);
var database_row_shard_planning_1 = require("./database-row-shard-planning");
Object.defineProperty(exports, "canonicalDatabaseRowOrder", { enumerable: true, get: function () { return database_row_shard_planning_1.canonicalDatabaseRowOrder; } });
Object.defineProperty(exports, "databaseDirectoryShardIndexHolds", { enumerable: true, get: function () { return database_row_shard_planning_1.databaseDirectoryShardIndexHolds; } });
Object.defineProperty(exports, "databaseRowShardId", { enumerable: true, get: function () { return database_row_shard_planning_1.databaseRowShardId; } });
Object.defineProperty(exports, "fitDatabaseRowShardPrefix", { enumerable: true, get: function () { return database_row_shard_planning_1.fitDatabaseRowShardPrefix; } });
Object.defineProperty(exports, "nextDatabaseRowShardIndex", { enumerable: true, get: function () { return database_row_shard_planning_1.nextDatabaseRowShardIndex; } });
Object.defineProperty(exports, "nextDatabaseShardIndex", { enumerable: true, get: function () { return database_row_shard_planning_1.nextDatabaseShardIndex; } });
Object.defineProperty(exports, "partitionDatabaseRowShardRows", { enumerable: true, get: function () { return database_row_shard_planning_1.partitionDatabaseRowShardRows; } });
Object.defineProperty(exports, "planDatabaseRowInsertion", { enumerable: true, get: function () { return database_row_shard_planning_1.planDatabaseRowInsertion; } });
Object.defineProperty(exports, "planDatabaseRowOrderChange", { enumerable: true, get: function () { return database_row_shard_planning_1.planDatabaseRowOrderChange; } });
Object.defineProperty(exports, "planDatabaseRowOrderSplices", { enumerable: true, get: function () { return database_row_shard_planning_1.planDatabaseRowOrderSplices; } });
Object.defineProperty(exports, "planDatabaseRowShardMerges", { enumerable: true, get: function () { return database_row_shard_planning_1.planDatabaseRowShardMerges; } });
var document_state_forward_1 = require("./document-state-forward");
Object.defineProperty(exports, "forwardDocumentToState", { enumerable: true, get: function () { return document_state_forward_1.forwardDocumentToState; } });
Object.defineProperty(exports, "forwardDocumentUpdate", { enumerable: true, get: function () { return document_state_forward_1.forwardDocumentUpdate; } });
const database_row_fingerprint_1 = require("./database-row-fingerprint");
var database_search_js_1 = require("./database-search.js");
Object.defineProperty(exports, "databaseSearchCellText", { enumerable: true, get: function () { return database_search_js_1.databaseSearchCellText; } });
Object.defineProperty(exports, "matchesDatabaseRowSearch", { enumerable: true, get: function () { return database_search_js_1.matchesDatabaseRowSearch; } });
Object.defineProperty(exports, "matchesDatabaseSearchText", { enumerable: true, get: function () { return database_search_js_1.matchesDatabaseSearchText; } });
Object.defineProperty(exports, "normalizeDatabaseSearchQuery", { enumerable: true, get: function () { return database_search_js_1.normalizeDatabaseSearchQuery; } });
var database_search_js_2 = require("./database-search.js");
Object.defineProperty(exports, "calculateDatabaseProjectionAggregate", { enumerable: true, get: function () { return database_search_js_2.calculateDatabaseProjectionAggregate; } });
Object.defineProperty(exports, "createDatabaseProjectionAggregate", { enumerable: true, get: function () { return database_search_js_2.createDatabaseProjectionAggregate; } });
Object.defineProperty(exports, "isEmptyDatabaseProjectionValue", { enumerable: true, get: function () { return database_search_js_2.isEmptyDatabaseProjectionValue; } });
Object.defineProperty(exports, "matchesDatabaseProjectionPredicate", { enumerable: true, get: function () { return database_search_js_2.matchesDatabaseProjectionPredicate; } });
Object.defineProperty(exports, "normalizeDatabaseProjectionWindow", { enumerable: true, get: function () { return database_search_js_2.normalizeDatabaseProjectionWindow; } });
Object.defineProperty(exports, "parseDatabaseProjectionDate", { enumerable: true, get: function () { return database_search_js_2.parseDatabaseProjectionDate; } });
Object.defineProperty(exports, "prepareDatabaseProjectionPredicate", { enumerable: true, get: function () { return database_search_js_2.prepareDatabaseProjectionPredicate; } });
var database_view_filter_1 = require("./database-view-filter");
Object.defineProperty(exports, "databaseAttachmentFilterFunctions", { enumerable: true, get: function () { return database_view_filter_1.databaseAttachmentFilterFunctions; } });
Object.defineProperty(exports, "databaseViewFilterFunctions", { enumerable: true, get: function () { return database_view_filter_1.databaseViewFilterFunctions; } });
Object.defineProperty(exports, "getDatabaseViewFilterFunction", { enumerable: true, get: function () { return database_view_filter_1.getDatabaseViewFilterFunction; } });
Object.defineProperty(exports, "isOlderThanDays", { enumerable: true, get: function () { return database_view_filter_1.isOlderThanDays; } });
Object.defineProperty(exports, "matchesDatabaseViewFilter", { enumerable: true, get: function () { return database_view_filter_1.matchesDatabaseViewFilter; } });
const database_document_identity_1 = require("./database-document-identity");
const database_manifest_fields_1 = require("./database-manifest-fields");
const database_shard_directory_parts_1 = require("./database-shard-directory-parts");
const database_shard_manifest_crdt_1 = require("./database-shard-manifest-crdt");
const database_storage_errors_1 = require("./database-storage-errors");
const database_value_summary_1 = require("./database-value-summary");
const database_document_scheme_1 = require("./generated/database-document-scheme");
var database_document_identity_2 = require("./database-document-identity");
Object.defineProperty(exports, "collectDatabaseStorageSyncDocIds", { enumerable: true, get: function () { return database_document_identity_2.collectDatabaseStorageSyncDocIds; } });
Object.defineProperty(exports, "createLocalDatabaseRootDocId", { enumerable: true, get: function () { return database_document_identity_2.createLocalDatabaseRootDocId; } });
Object.defineProperty(exports, "createServerDatabaseDirectoryPartDocId", { enumerable: true, get: function () { return database_document_identity_2.createServerDatabaseDirectoryPartDocId; } });
Object.defineProperty(exports, "createServerDatabaseDirectoryPartDocIdPrefix", { enumerable: true, get: function () { return database_document_identity_2.createServerDatabaseDirectoryPartDocIdPrefix; } });
Object.defineProperty(exports, "createServerDatabaseDocIdPrefix", { enumerable: true, get: function () { return database_document_identity_2.createServerDatabaseDocIdPrefix; } });
Object.defineProperty(exports, "createServerDatabaseRootDocId", { enumerable: true, get: function () { return database_document_identity_2.createServerDatabaseRootDocId; } });
Object.defineProperty(exports, "createServerDatabaseRowShardDocId", { enumerable: true, get: function () { return database_document_identity_2.createServerDatabaseRowShardDocId; } });
Object.defineProperty(exports, "createServerDatabaseRowShardDocIdPrefix", { enumerable: true, get: function () { return database_document_identity_2.createServerDatabaseRowShardDocIdPrefix; } });
Object.defineProperty(exports, "createServerPagePartDocId", { enumerable: true, get: function () { return database_document_identity_2.createServerPagePartDocId; } });
Object.defineProperty(exports, "createServerPagePartDocIdPrefix", { enumerable: true, get: function () { return database_document_identity_2.createServerPagePartDocIdPrefix; } });
Object.defineProperty(exports, "databaseDocumentCollectionRoot", { enumerable: true, get: function () { return database_document_identity_2.databaseDocumentCollectionRoot; } });
Object.defineProperty(exports, "extractDatabaseIdFromRootDocId", { enumerable: true, get: function () { return database_document_identity_2.extractDatabaseIdFromRootDocId; } });
Object.defineProperty(exports, "isLocalDatabaseRootDocId", { enumerable: true, get: function () { return database_document_identity_2.isLocalDatabaseRootDocId; } });
Object.defineProperty(exports, "isLocalDatabaseRowShardDocId", { enumerable: true, get: function () { return database_document_identity_2.isLocalDatabaseRowShardDocId; } });
Object.defineProperty(exports, "isServerDatabaseDirectoryPartDocId", { enumerable: true, get: function () { return database_document_identity_2.isServerDatabaseDirectoryPartDocId; } });
Object.defineProperty(exports, "isServerDatabaseRootDocId", { enumerable: true, get: function () { return database_document_identity_2.isServerDatabaseRootDocId; } });
Object.defineProperty(exports, "isServerDatabaseRowShardDocId", { enumerable: true, get: function () { return database_document_identity_2.isServerDatabaseRowShardDocId; } });
Object.defineProperty(exports, "isServerPagePartDocId", { enumerable: true, get: function () { return database_document_identity_2.isServerPagePartDocId; } });
Object.defineProperty(exports, "normalizeDatabaseBlockId", { enumerable: true, get: function () { return database_document_identity_2.normalizeDatabaseBlockId; } });
Object.defineProperty(exports, "parseLocalDatabaseRootDocId", { enumerable: true, get: function () { return database_document_identity_2.parseLocalDatabaseRootDocId; } });
Object.defineProperty(exports, "parseLocalDatabaseRowShardDocId", { enumerable: true, get: function () { return database_document_identity_2.parseLocalDatabaseRowShardDocId; } });
Object.defineProperty(exports, "parseServerDatabaseDirectoryPartDocId", { enumerable: true, get: function () { return database_document_identity_2.parseServerDatabaseDirectoryPartDocId; } });
Object.defineProperty(exports, "parseServerDatabaseDocId", { enumerable: true, get: function () { return database_document_identity_2.parseServerDatabaseDocId; } });
Object.defineProperty(exports, "parseServerDatabaseRootDocId", { enumerable: true, get: function () { return database_document_identity_2.parseServerDatabaseRootDocId; } });
Object.defineProperty(exports, "parseServerDatabaseRowShardDocId", { enumerable: true, get: function () { return database_document_identity_2.parseServerDatabaseRowShardDocId; } });
Object.defineProperty(exports, "parseServerPagePartDocId", { enumerable: true, get: function () { return database_document_identity_2.parseServerPagePartDocId; } });
Object.defineProperty(exports, "SERVER_DATABASE_ROOT_DOC_ID_LIKE_PATTERN", { enumerable: true, get: function () { return database_document_identity_2.SERVER_DATABASE_ROOT_DOC_ID_LIKE_PATTERN; } });
const database_large_data_policy_1 = require("./database-large-data-policy");
const database_limits_1 = require("./database-limits");
var calendar_policy_1 = require("./calendar-policy");
Object.defineProperty(exports, "CALENDAR_MAX_VISIBLE_SOURCES", { enumerable: true, get: function () { return calendar_policy_1.CALENDAR_MAX_VISIBLE_SOURCES; } });
var canvas_database_layout_1 = require("./canvas-database-layout");
Object.defineProperty(exports, "CANVAS_DATABASE_LIVE_CHROME_HEIGHT", { enumerable: true, get: function () { return canvas_database_layout_1.CANVAS_DATABASE_LIVE_CHROME_HEIGHT; } });
Object.defineProperty(exports, "CANVAS_DATABASE_PADDING_X", { enumerable: true, get: function () { return canvas_database_layout_1.CANVAS_DATABASE_PADDING_X; } });
Object.defineProperty(exports, "CANVAS_DATABASE_PRESENTATION_HEADER_HEIGHT", { enumerable: true, get: function () { return canvas_database_layout_1.CANVAS_DATABASE_PRESENTATION_HEADER_HEIGHT; } });
Object.defineProperty(exports, "CANVAS_DATABASE_ROW_WINDOW_FOOTER_HEIGHT", { enumerable: true, get: function () { return canvas_database_layout_1.CANVAS_DATABASE_ROW_WINDOW_FOOTER_HEIGHT; } });
Object.defineProperty(exports, "CANVAS_DATABASE_TABLE_GROUP_FOOTER_HEIGHT", { enumerable: true, get: function () { return canvas_database_layout_1.CANVAS_DATABASE_TABLE_GROUP_FOOTER_HEIGHT; } });
Object.defineProperty(exports, "DATABASE_TABLE_ADD_COLUMN_WIDTH", { enumerable: true, get: function () { return canvas_database_layout_1.DATABASE_TABLE_ADD_COLUMN_WIDTH; } });
Object.defineProperty(exports, "DATABASE_TABLE_HEADER_HEIGHT", { enumerable: true, get: function () { return canvas_database_layout_1.DATABASE_TABLE_HEADER_HEIGHT; } });
Object.defineProperty(exports, "DATABASE_TABLE_ROW_GUTTER_WIDTH", { enumerable: true, get: function () { return canvas_database_layout_1.DATABASE_TABLE_ROW_GUTTER_WIDTH; } });
Object.defineProperty(exports, "DATABASE_TABLE_ROW_HEIGHT", { enumerable: true, get: function () { return canvas_database_layout_1.DATABASE_TABLE_ROW_HEIGHT; } });
Object.defineProperty(exports, "DATABASE_TABLE_STATS_BAR_HEIGHT", { enumerable: true, get: function () { return canvas_database_layout_1.DATABASE_TABLE_STATS_BAR_HEIGHT; } });
Object.defineProperty(exports, "estimateCanvasDatabaseLiveTableHeight", { enumerable: true, get: function () { return canvas_database_layout_1.estimateCanvasDatabaseLiveTableHeight; } });
var canvas_placement_1 = require("./canvas-placement");
Object.defineProperty(exports, "createRightSideBranchCandidates", { enumerable: true, get: function () { return canvas_placement_1.createRightSideBranchCandidates; } });
Object.defineProperty(exports, "DEFAULT_CANVAS_PLACEMENT_GAP", { enumerable: true, get: function () { return canvas_placement_1.DEFAULT_CANVAS_PLACEMENT_GAP; } });
Object.defineProperty(exports, "findFreeCanvasRect", { enumerable: true, get: function () { return canvas_placement_1.findFreeCanvasRect; } });
Object.defineProperty(exports, "findFreeCanvasRowRects", { enumerable: true, get: function () { return canvas_placement_1.findFreeCanvasRowRects; } });
var catalog_image_1 = require("./catalog-image");
Object.defineProperty(exports, "isCatalogImage", { enumerable: true, get: function () { return catalog_image_1.isCatalogImage; } });
__exportStar(require("./database-attachment-order"), exports);
__exportStar(require("./database-bytes-text"), exports);
__exportStar(require("./database-cell-attachment-source"), exports);
__exportStar(require("./database-cell-blobs"), exports);
__exportStar(require("./database-cell-convert"), exports);
__exportStar(require("./database-cell-text-parse"), exports);
__exportStar(require("./database-column-lineage"), exports);
__exportStar(require("./database-deleted-columns"), exports);
var database_large_data_policy_2 = require("./database-large-data-policy");
Object.defineProperty(exports, "DATABASE_LARGE_DATA_POLICY", { enumerable: true, get: function () { return database_large_data_policy_2.DATABASE_LARGE_DATA_POLICY; } });
Object.defineProperty(exports, "DOCUMENT_PRODUCT_HARD_LIMIT_BYTES", { enumerable: true, get: function () { return database_large_data_policy_2.DOCUMENT_PRODUCT_HARD_LIMIT_BYTES; } });
__exportStar(require("./database-limits"), exports);
__exportStar(require("./database-relation-pair"), exports);
var database_title_cell_1 = require("./database-title-cell");
Object.defineProperty(exports, "resolveDatabaseCellStorageKey", { enumerable: true, get: function () { return database_title_cell_1.resolveDatabaseCellStorageKey; } });
Object.defineProperty(exports, "resolveDatabaseCellStorageKeyFromHas", { enumerable: true, get: function () { return database_title_cell_1.resolveDatabaseCellStorageKeyFromHas; } });
var database_trash_protection_1 = require("./database-trash-protection");
Object.defineProperty(exports, "isDatabaseTrashBlocked", { enumerable: true, get: function () { return database_trash_protection_1.isDatabaseTrashBlocked; } });
var database_view_defaults_1 = require("./database-view-defaults");
Object.defineProperty(exports, "createCanonicalCalendarViewData", { enumerable: true, get: function () { return database_view_defaults_1.createCanonicalCalendarViewData; } });
Object.defineProperty(exports, "createCanonicalGanttViewData", { enumerable: true, get: function () { return database_view_defaults_1.createCanonicalGanttViewData; } });
Object.defineProperty(exports, "createCanonicalKanbanViewData", { enumerable: true, get: function () { return database_view_defaults_1.createCanonicalKanbanViewData; } });
Object.defineProperty(exports, "createCanonicalTableViewData", { enumerable: true, get: function () { return database_view_defaults_1.createCanonicalTableViewData; } });
Object.defineProperty(exports, "DATABASE_VIEW_MODES", { enumerable: true, get: function () { return database_view_defaults_1.DATABASE_VIEW_MODES; } });
Object.defineProperty(exports, "getCanonicalKanbanVisiblePropertyIds", { enumerable: true, get: function () { return database_view_defaults_1.getCanonicalKanbanVisiblePropertyIds; } });
Object.defineProperty(exports, "isCanonicalKanbanL2PropertyShape", { enumerable: true, get: function () { return database_view_defaults_1.isCanonicalKanbanL2PropertyShape; } });
Object.defineProperty(exports, "isCanonicalTablePropertyVisible", { enumerable: true, get: function () { return database_view_defaults_1.isCanonicalTablePropertyVisible; } });
Object.defineProperty(exports, "KANBAN_DEFAULT_VISIBLE_BODY_PROPERTY_COUNT", { enumerable: true, get: function () { return database_view_defaults_1.KANBAN_DEFAULT_VISIBLE_BODY_PROPERTY_COUNT; } });
Object.defineProperty(exports, "KANBAN_DEFAULT_VISIBLE_SYSTEM_BODY_PROPERTY_TYPES", { enumerable: true, get: function () { return database_view_defaults_1.KANBAN_DEFAULT_VISIBLE_SYSTEM_BODY_PROPERTY_TYPES; } });
Object.defineProperty(exports, "KANBAN_L2_GROUP_MATCHER_NAMES", { enumerable: true, get: function () { return database_view_defaults_1.KANBAN_L2_GROUP_MATCHER_NAMES; } });
Object.defineProperty(exports, "KANBAN_L2_GROUPABLE_PROPERTY_TYPES", { enumerable: true, get: function () { return database_view_defaults_1.KANBAN_L2_GROUPABLE_PROPERTY_TYPES; } });
Object.defineProperty(exports, "KANBAN_SYSTEM_BODY_PROPERTY_TYPES", { enumerable: true, get: function () { return database_view_defaults_1.KANBAN_SYSTEM_BODY_PROPERTY_TYPES; } });
Object.defineProperty(exports, "orderCanonicalKanbanProperties", { enumerable: true, get: function () { return database_view_defaults_1.orderCanonicalKanbanProperties; } });
Object.defineProperty(exports, "TABLE_DEFAULT_HIDDEN_PROPERTY_TYPES", { enumerable: true, get: function () { return database_view_defaults_1.TABLE_DEFAULT_HIDDEN_PROPERTY_TYPES; } });
var file_index_1 = require("./file-index");
Object.defineProperty(exports, "decodeFileIndexRowSourceBlockId", { enumerable: true, get: function () { return file_index_1.decodeFileIndexRowSourceBlockId; } });
Object.defineProperty(exports, "FILE_INDEX_COLUMN_IDS", { enumerable: true, get: function () { return file_index_1.FILE_INDEX_COLUMN_IDS; } });
Object.defineProperty(exports, "FILE_INDEX_COLUMNS", { enumerable: true, get: function () { return file_index_1.FILE_INDEX_COLUMNS; } });
Object.defineProperty(exports, "FILE_INDEX_DATABASE_ID_PREFIX", { enumerable: true, get: function () { return file_index_1.FILE_INDEX_DATABASE_ID_PREFIX; } });
Object.defineProperty(exports, "FILE_INDEX_DATABASE_PROTECTION_PROPS", { enumerable: true, get: function () { return file_index_1.FILE_INDEX_DATABASE_PROTECTION_PROPS; } });
Object.defineProperty(exports, "FILE_INDEX_HIGHLIGHT_EVENTS", { enumerable: true, get: function () { return file_index_1.FILE_INDEX_HIGHLIGHT_EVENTS; } });
Object.defineProperty(exports, "FILE_INDEX_HIGHLIGHT_SCOPES", { enumerable: true, get: function () { return file_index_1.FILE_INDEX_HIGHLIGHT_SCOPES; } });
Object.defineProperty(exports, "FILE_INDEX_MANAGED_BY", { enumerable: true, get: function () { return file_index_1.FILE_INDEX_MANAGED_BY; } });
Object.defineProperty(exports, "FILE_INDEX_ROW_HIGHLIGHT_ATTRIBUTE", { enumerable: true, get: function () { return file_index_1.FILE_INDEX_ROW_HIGHLIGHT_ATTRIBUTE; } });
Object.defineProperty(exports, "FILE_INDEX_ROW_ID_PREFIX", { enumerable: true, get: function () { return file_index_1.FILE_INDEX_ROW_ID_PREFIX; } });
Object.defineProperty(exports, "FILE_INDEX_SOURCE_HIGHLIGHT_CLASS", { enumerable: true, get: function () { return file_index_1.FILE_INDEX_SOURCE_HIGHLIGHT_CLASS; } });
Object.defineProperty(exports, "isFileIndexDatabaseId", { enumerable: true, get: function () { return file_index_1.isFileIndexDatabaseId; } });
Object.defineProperty(exports, "isFileIndexManagedColumnData", { enumerable: true, get: function () { return file_index_1.isFileIndexManagedColumnData; } });
Object.defineProperty(exports, "isFileIndexSystemColumnId", { enumerable: true, get: function () { return file_index_1.isFileIndexSystemColumnId; } });
Object.defineProperty(exports, "normalizeAttachmentCell", { enumerable: true, get: function () { return file_index_1.normalizeAttachmentCell; } });
__exportStar(require("./generated/database-document-scheme"), exports);
var history_policy_1 = require("./history-policy");
Object.defineProperty(exports, "HISTORY_SNAPSHOT_INTERVAL_MS", { enumerable: true, get: function () { return history_policy_1.HISTORY_SNAPSHOT_INTERVAL_MS; } });
Object.defineProperty(exports, "HISTORY_SNAPSHOT_INTERVAL_SECONDS", { enumerable: true, get: function () { return history_policy_1.HISTORY_SNAPSHOT_INTERVAL_SECONDS; } });
Object.defineProperty(exports, "historySnapshotWindowIndex", { enumerable: true, get: function () { return history_policy_1.historySnapshotWindowIndex; } });
Object.defineProperty(exports, "historySnapshotWindowStartMs", { enumerable: true, get: function () { return history_policy_1.historySnapshotWindowStartMs; } });
var status_tracking_1 = require("./status-tracking");
Object.defineProperty(exports, "filterRowsByStatusTracking", { enumerable: true, get: function () { return status_tracking_1.filterRowsByStatusTracking; } });
Object.defineProperty(exports, "isStatusTrackingPredicateConfigured", { enumerable: true, get: function () { return status_tracking_1.isStatusTrackingPredicateConfigured; } });
Object.defineProperty(exports, "isStatusTrackingRowOpen", { enumerable: true, get: function () { return status_tracking_1.isStatusTrackingRowOpen; } });
Object.defineProperty(exports, "statusTrackingCellState", { enumerable: true, get: function () { return status_tracking_1.statusTrackingCellState; } });
Object.defineProperty(exports, "statusTrackingOptionLookup", { enumerable: true, get: function () { return status_tracking_1.statusTrackingOptionLookup; } });
Object.defineProperty(exports, "statusTrackingRowStates", { enumerable: true, get: function () { return status_tracking_1.statusTrackingRowStates; } });
var system_managed_visibility_1 = require("./system-managed-visibility");
Object.defineProperty(exports, "APP_BASE_STANDARD_DATABASE_MANAGED_BY_PREFIX", { enumerable: true, get: function () { return system_managed_visibility_1.APP_BASE_STANDARD_DATABASE_MANAGED_BY_PREFIX; } });
Object.defineProperty(exports, "APP_BASE_STANDARD_USER_FACING_DATABASE_ROLES", { enumerable: true, get: function () { return system_managed_visibility_1.APP_BASE_STANDARD_USER_FACING_DATABASE_ROLES; } });
Object.defineProperty(exports, "isHiddenSystemManagedDatabase", { enumerable: true, get: function () { return system_managed_visibility_1.isHiddenSystemManagedDatabase; } });
Object.defineProperty(exports, "isUserFacingAppBaseStandardDatabaseRole", { enumerable: true, get: function () { return system_managed_visibility_1.isUserFacingAppBaseStandardDatabaseRole; } });
Object.defineProperty(exports, "resolveAppBaseStandardDatabaseRole", { enumerable: true, get: function () { return system_managed_visibility_1.resolveAppBaseStandardDatabaseRole; } });
Object.defineProperty(exports, "VIEW_CONFIG_MANAGED_BY", { enumerable: true, get: function () { return system_managed_visibility_1.VIEW_CONFIG_MANAGED_BY; } });
var temporal_profile_1 = require("./temporal-profile");
Object.defineProperty(exports, "isTemporalProfileViewType", { enumerable: true, get: function () { return temporal_profile_1.isTemporalProfileViewType; } });
Object.defineProperty(exports, "resolveTemporalDateColumns", { enumerable: true, get: function () { return temporal_profile_1.resolveTemporalDateColumns; } });
Object.defineProperty(exports, "resolveTemporalProfileColumn", { enumerable: true, get: function () { return temporal_profile_1.resolveTemporalProfileColumn; } });
Object.defineProperty(exports, "TEMPORAL_PROFILE_ROLE_FIELDS", { enumerable: true, get: function () { return temporal_profile_1.TEMPORAL_PROFILE_ROLE_FIELDS; } });
Object.defineProperty(exports, "TEMPORAL_PROFILE_ROLE_PRIMARY_TYPE", { enumerable: true, get: function () { return temporal_profile_1.TEMPORAL_PROFILE_ROLE_PRIMARY_TYPE; } });
Object.defineProperty(exports, "TEMPORAL_PROFILE_ROLES", { enumerable: true, get: function () { return temporal_profile_1.TEMPORAL_PROFILE_ROLES; } });
Object.defineProperty(exports, "TEMPORAL_PROFILE_VIEW_TYPES", { enumerable: true, get: function () { return temporal_profile_1.TEMPORAL_PROFILE_VIEW_TYPES; } });
Object.defineProperty(exports, "temporalProfileRoleAcceptsPropertyType", { enumerable: true, get: function () { return temporal_profile_1.temporalProfileRoleAcceptsPropertyType; } });
Object.defineProperty(exports, "temporalProfileRoleColumnId", { enumerable: true, get: function () { return temporal_profile_1.temporalProfileRoleColumnId; } });
var trash_connectors_1 = require("./trash-connectors");
Object.defineProperty(exports, "collectAttachedCanvasConnectorIds", { enumerable: true, get: function () { return trash_connectors_1.collectAttachedCanvasConnectorIds; } });
Object.defineProperty(exports, "findCanvasSurfaceElements", { enumerable: true, get: function () { return trash_connectors_1.findCanvasSurfaceElements; } });
Object.defineProperty(exports, "leaveCanvasGroup", { enumerable: true, get: function () { return trash_connectors_1.leaveCanvasGroup; } });
Object.defineProperty(exports, "restorableTrashConnectors", { enumerable: true, get: function () { return trash_connectors_1.restorableTrashConnectors; } });
Object.defineProperty(exports, "restoreTrashCanvasMembers", { enumerable: true, get: function () { return trash_connectors_1.restoreTrashCanvasMembers; } });
Object.defineProperty(exports, "takeTrashCanvasMembers", { enumerable: true, get: function () { return trash_connectors_1.takeTrashCanvasMembers; } });
var view_backed_app_resource_id_1 = require("./view-backed-app-resource-id");
Object.defineProperty(exports, "parseViewBackedAppResourceId", { enumerable: true, get: function () { return view_backed_app_resource_id_1.parseViewBackedAppResourceId; } });
Object.defineProperty(exports, "viewBackedAppResourceId", { enumerable: true, get: function () { return view_backed_app_resource_id_1.viewBackedAppResourceId; } });
Object.defineProperty(exports, "ViewBackedAppResourceIdError", { enumerable: true, get: function () { return view_backed_app_resource_id_1.ViewBackedAppResourceIdError; } });
exports.DEFAULT_CANVAS_DATABASE_WIDTH = 800;
exports.DEFAULT_CANVAS_DATABASE_HEIGHT = 300;
exports.MIN_CANVAS_DATABASE_HEIGHT = 180;
exports.MAX_CANVAS_DATABASE_HEIGHT = 1440;
exports.CANVAS_DATABASE_LAYOUT_NODE_WIDTH = exports.DEFAULT_CANVAS_DATABASE_WIDTH;
exports.CANVAS_DATABASE_LAYOUT_NODE_HEIGHT = exports.MAX_CANVAS_DATABASE_HEIGHT;
exports.CANVAS_DATABASE_LAYOUT_COLUMN_GAP = 480;
exports.CANVAS_DATABASE_LAYOUT_ROW_GAP = 260;
exports.CANVAS_DATABASE_LAYOUT_PAGE_NODE_RESERVED_HEIGHT = 720;
exports.CANVAS_DATABASE_LAYOUT_COLUMN_STEP = exports.CANVAS_DATABASE_LAYOUT_NODE_WIDTH + exports.CANVAS_DATABASE_LAYOUT_COLUMN_GAP;
exports.CANVAS_DATABASE_LAYOUT_ROW_STEP = exports.CANVAS_DATABASE_LAYOUT_NODE_HEIGHT + exports.CANVAS_DATABASE_LAYOUT_ROW_GAP;
function createCanvasDatabaseLayout(input) {
    return {
        index: input.index,
        xywh: [
            input.x,
            input.y,
            input.width ?? exports.CANVAS_DATABASE_LAYOUT_NODE_WIDTH,
            input.height ?? exports.CANVAS_DATABASE_LAYOUT_NODE_HEIGHT,
        ],
    };
}
function createCanvasDatabaseGridLayout(index, column, row) {
    return createCanvasDatabaseLayout({
        index,
        x: column * exports.CANVAS_DATABASE_LAYOUT_COLUMN_STEP,
        y: exports.CANVAS_DATABASE_LAYOUT_PAGE_NODE_RESERVED_HEIGHT +
            row * exports.CANVAS_DATABASE_LAYOUT_ROW_STEP,
    });
}
function canvasDatabaseGeometry(layout) {
    const [x, y, width, height] = layout.xywh;
    return { x, y, width, height };
}
function serializeCanvasDatabaseXYWH(layout) {
    return JSON.stringify(layout.xywh);
}
exports.SELECT_OPTION_COLORS = [
    {
        color: '#ef4444',
        name: 'Red',
    },
    {
        color: '#c026d3',
        name: 'Magenta',
    },
    {
        color: '#f97316',
        name: 'Orange',
    },
    {
        color: '#eab308',
        name: 'Yellow',
    },
    {
        color: '#22c55e',
        name: 'Green',
    },
    {
        color: '#14b8a6',
        name: 'Teal',
    },
    {
        color: '#2563eb',
        name: 'Blue',
    },
    {
        color: '#7c3aed',
        name: 'Purple',
    },
    {
        color: '#475569',
        name: 'Grey',
    },
];
exports.SELECT_OPTION_COLOR_VALUES = exports.SELECT_OPTION_COLORS.map(color => color.color);
exports.SELECT_OPTION_COLOR_BY_NAME = Object.fromEntries(exports.SELECT_OPTION_COLORS.map(color => [color.name, color.color]));
function getRandomSelectOptionColor(random = Math.random) {
    const index = Math.floor(random() * exports.SELECT_OPTION_COLOR_VALUES.length);
    return exports.SELECT_OPTION_COLOR_VALUES[index] ?? exports.SELECT_OPTION_COLOR_VALUES[0];
}
function createSelectOptionColorPicker(random = Math.random) {
    let colors = [...exports.SELECT_OPTION_COLOR_VALUES];
    return () => {
        if (colors.length === 0) {
            colors = [...exports.SELECT_OPTION_COLOR_VALUES];
        }
        const index = Math.floor(random() * colors.length);
        const color = colors.splice(index, 1)[0];
        return color ?? exports.SELECT_OPTION_COLOR_VALUES[0];
    };
}
exports.INVALID_DATABASE_STORAGE_MESSAGE = 'database row data must be written through row-sharded storage';
exports.ROW_SHARDED_DATABASE_GATE_MESSAGE = 'row-sharded database storage passes Gate-C and is released';
exports.DATABASE_ROW_CREATED_TIME_FIELD_ID = 'created-time';
exports.DATABASE_ROW_CREATED_BY_FIELD_ID = 'created-by';
exports.DATABASE_ROW_UPDATED_TIME_FIELD_ID = 'updated-time';
exports.DATABASE_ROW_UPDATED_BY_FIELD_ID = 'updated-by';
exports.DATABASE_ROW_SYSTEM_FIELD_IDS = [
    exports.DATABASE_ROW_CREATED_TIME_FIELD_ID,
    exports.DATABASE_ROW_CREATED_BY_FIELD_ID,
    exports.DATABASE_ROW_UPDATED_TIME_FIELD_ID,
    exports.DATABASE_ROW_UPDATED_BY_FIELD_ID,
];
/** Shared property metadata used by client models and snapshot projections. */
exports.DATABASE_ROW_SYSTEM_FIELD_NAMES = {
    'created-time': 'Created Time',
    'created-by': 'Created By',
    'updated-time': 'Updated Time',
    'updated-by': 'Updated By',
};
function isDatabaseRowSystemFieldId(fieldId) {
    return exports.DATABASE_ROW_SYSTEM_FIELD_IDS.includes(fieldId);
}
function databaseRowSystemFieldCell(columnId, value) {
    return { columnId, value };
}
function createDatabaseRowCreationSystemFieldCells(input) {
    const userId = input.userId ?? '';
    return {
        [exports.DATABASE_ROW_CREATED_TIME_FIELD_ID]: databaseRowSystemFieldCell(exports.DATABASE_ROW_CREATED_TIME_FIELD_ID, input.now),
        [exports.DATABASE_ROW_CREATED_BY_FIELD_ID]: databaseRowSystemFieldCell(exports.DATABASE_ROW_CREATED_BY_FIELD_ID, userId),
        [exports.DATABASE_ROW_UPDATED_TIME_FIELD_ID]: databaseRowSystemFieldCell(exports.DATABASE_ROW_UPDATED_TIME_FIELD_ID, input.now),
        [exports.DATABASE_ROW_UPDATED_BY_FIELD_ID]: databaseRowSystemFieldCell(exports.DATABASE_ROW_UPDATED_BY_FIELD_ID, userId),
    };
}
function createDatabaseRowUpdateSystemFieldCells(input) {
    const userId = input.userId ?? '';
    const cells = {
        [exports.DATABASE_ROW_UPDATED_TIME_FIELD_ID]: databaseRowSystemFieldCell(exports.DATABASE_ROW_UPDATED_TIME_FIELD_ID, input.now),
    };
    if (input.updatedByValue !== userId) {
        cells[exports.DATABASE_ROW_UPDATED_BY_FIELD_ID] = databaseRowSystemFieldCell(exports.DATABASE_ROW_UPDATED_BY_FIELD_ID, userId);
    }
    if (typeof input.createdTimeValue !== 'number') {
        cells[exports.DATABASE_ROW_CREATED_TIME_FIELD_ID] = databaseRowSystemFieldCell(exports.DATABASE_ROW_CREATED_TIME_FIELD_ID, input.now);
    }
    if (typeof input.createdByValue !== 'string') {
        cells[exports.DATABASE_ROW_CREATED_BY_FIELD_ID] = databaseRowSystemFieldCell(exports.DATABASE_ROW_CREATED_BY_FIELD_ID, userId);
    }
    return cells;
}
/**
 * How a cell is kept inside a row of a row shard document.
 *
 * Ordinary cells are kept as `{ columnId, value }`. The four system fields are
 * kept as the value alone: their column id is the key they are stored under,
 * and one of them is rewritten with every change of the row. Rows written
 * before this rule keep the object form, so every reader takes both forms
 * through `readDatabaseRowStoredCell`.
 */
function toDatabaseRowStoredCell(fieldId, cell) {
    if (!isDatabaseRowSystemFieldId(fieldId))
        return cell;
    if (!cell || typeof cell !== 'object' || Array.isArray(cell))
        return cell;
    const value = cell.value;
    return typeof value === 'number' || typeof value === 'string' ? value : cell;
}
/** Reads a stored cell in either form. `null` when the entry is not a cell. */
function readDatabaseRowStoredCell(fieldId, stored) {
    if (stored && typeof stored === 'object' && !Array.isArray(stored)) {
        const cell = stored;
        return typeof cell.columnId === 'string'
            ? { columnId: cell.columnId, value: cell.value }
            : null;
    }
    if (isDatabaseRowSystemFieldId(fieldId) &&
        (typeof stored === 'number' || typeof stored === 'string')) {
        return { columnId: fieldId, value: stored };
    }
    return null;
}
/** The value of a stored cell in either form. */
function readDatabaseRowStoredCellValue(fieldId, stored) {
    if (stored && typeof stored === 'object' && !Array.isArray(stored)) {
        return stored.value;
    }
    return isDatabaseRowSystemFieldId(fieldId) &&
        (typeof stored === 'number' || typeof stored === 'string')
        ? stored
        : undefined;
}
/**
 * When a row was created: its "created" system cell, or `indexedAt` for a row
 * whose cell is not written yet (the same rule as
 * createDatabaseRowUpdateSystemFieldCells, which stamps the write time).
 */
function readDatabaseRowCreatedAt(cells, indexedAt) {
    const value = readDatabaseRowStoredCellValue(exports.DATABASE_ROW_CREATED_TIME_FIELD_ID, cells[exports.DATABASE_ROW_CREATED_TIME_FIELD_ID]);
    return typeof value === 'number' && Number.isFinite(value)
        ? new Date(value)
        : indexedAt;
}
function isDatabaseRowSystemFieldCell(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
        return false;
    }
    const cell = value;
    if (typeof cell.columnId !== 'string') {
        return false;
    }
    if (!isDatabaseRowSystemFieldId(cell.columnId)) {
        return false;
    }
    return typeof cell.value === 'number' || typeof cell.value === 'string';
}
exports.ROOT_DOC_ROW_MATERIALIZATION_HARD_LIMIT = database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.rootMaterializationGuard.rowHardLimit;
exports.DATABASE_COLUMN_HARD_LIMIT = database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.database.columnHardLimit;
exports.DATABASE_ROW_SHARD_TARGET_BYTES = database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.shard.targetBytes;
exports.DATABASE_ROW_SHARD_HARD_LIMIT_BYTES = database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.shard.hardLimitBytes;
exports.DATABASE_IMPORT_INLINE_ESTIMATED_BYTE_WARNING_THRESHOLD = database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.import.inlineEstimatedByteWarningThreshold;
exports.DATABASE_IMPORT_INLINE_ESTIMATED_BYTE_HARD_LIMIT = database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.import.inlineEstimatedByteHardLimit;
function assertDatabaseWriteShapeWithinLimits({ source, rowCount, columnCount, }) {
    (0, database_manifest_fields_1.assertNonNegativeInteger)(rowCount, 'Database row count');
    (0, database_manifest_fields_1.assertNonNegativeInteger)(columnCount, 'Database column count');
    if (rowCount > exports.ROOT_DOC_ROW_MATERIALIZATION_HARD_LIMIT) {
        throw new RangeError(`${source} has ${rowCount} rows; ${exports.INVALID_DATABASE_STORAGE_MESSAGE}. Owning-doc row materialization is not a product storage path.`);
    }
    if (columnCount > exports.DATABASE_COLUMN_HARD_LIMIT) {
        throw new RangeError(`${source} has ${columnCount} columns; product databases are limited to ${exports.DATABASE_COLUMN_HARD_LIMIT} columns.`);
    }
}
function assertDatabaseColumnShapeWithinLimits({ source, columnCount }, policy = database_limits_1.DATABASE_PRODUCT_LIMITS) {
    (0, database_manifest_fields_1.assertNonNegativeInteger)(columnCount, 'Database column count');
    if (columnCount > policy.columnHardLimit) {
        throw new database_limits_1.DatabaseLimitError({
            kind: 'columns',
            limit: policy.columnHardLimit,
            actual: columnCount,
            unit: 'columns',
        }, source);
    }
}
function estimateImportSampleCellBytes(sampleRows) {
    let cellCount = 0;
    let byteCount = 0;
    for (const row of sampleRows) {
        for (const cell of row) {
            cellCount += 1;
            byteCount += String(cell ?? '').length * 2;
        }
    }
    return cellCount === 0 ? 0 : Math.ceil(byteCount / cellCount);
}
function estimateDatabaseImportPreflight({ source, rowCount, columnCount, fileBytes = 0, sampleRows = [], fixedColumnOverhead = database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.import.fixedColumnOverhead, streamingRootIndexBytes, }) {
    (0, database_manifest_fields_1.assertNonNegativeInteger)(rowCount, 'Database import row count');
    (0, database_manifest_fields_1.assertNonNegativeInteger)(columnCount, 'Database import column count');
    (0, database_manifest_fields_1.assertNonNegativeInteger)(fileBytes, 'Database import file byte size');
    (0, database_manifest_fields_1.assertNonNegativeInteger)(fixedColumnOverhead, 'Database import fixed column overhead');
    const effectiveColumnCount = columnCount + fixedColumnOverhead;
    const cellCount = rowCount * effectiveColumnCount;
    const averageSampleCellBytes = estimateImportSampleCellBytes(sampleRows);
    const estimatedCellBytes = cellCount * (96 + Math.max(averageSampleCellBytes, 8));
    const estimatedTotalBytes = fileBytes + rowCount * 512 + columnCount * 512 + estimatedCellBytes;
    const estimatedShardCount = estimatedTotalBytes === 0
        ? 0
        : Math.ceil(estimatedTotalBytes / exports.DATABASE_ROW_SHARD_TARGET_BYTES);
    const warnings = [];
    const exceedsDatabaseLimits = rowCount > database_limits_1.DATABASE_PRODUCT_LIMITS.rowHardLimit ||
        columnCount > database_limits_1.DATABASE_PRODUCT_LIMITS.columnHardLimit;
    const databaseLimitsReason = `${source} has ${rowCount} rows and ${columnCount} columns; a database holds at most ${database_limits_1.DATABASE_PRODUCT_LIMITS.rowHardLimit} rows and ${database_limits_1.DATABASE_PRODUCT_LIMITS.columnHardLimit} columns. Split the file into several databases.`;
    if (streamingRootIndexBytes !== undefined) {
        (0, database_manifest_fields_1.assertNonNegativeInteger)(streamingRootIndexBytes, 'Database import root index estimate');
        const blocked = exceedsDatabaseLimits ||
            streamingRootIndexBytes > database_large_data_policy_1.DOCUMENT_PRODUCT_HARD_LIMIT_BYTES;
        return {
            source,
            rowCount,
            columnCount,
            effectiveColumnCount,
            cellCount,
            estimatedCellBytes,
            estimatedTotalBytes,
            estimatedShardCount,
            allowedAction: rowCount === 0 || columnCount === 0
                ? 'blocked-empty'
                : blocked
                    ? 'blocked-too-large'
                    : rowCount >
                        database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.import.inlineBlockRowThreshold ||
                        estimatedTotalBytes >
                            exports.DATABASE_IMPORT_INLINE_ESTIMATED_BYTE_HARD_LIMIT
                        ? 'queued-sharded-import'
                        : 'inline-sharded-import',
            warnings: [
                `${source} streams bounded row chunks; the ${estimatedTotalBytes}-byte total estimate is not an in-memory staging allocation.`,
            ],
            blockReason: rowCount === 0 || columnCount === 0
                ? `${source} has no importable rows or columns.`
                : blocked
                    ? exceedsDatabaseLimits
                        ? databaseLimitsReason
                        : `${source} exceeds streaming admission: at most ${database_large_data_policy_1.DOCUMENT_PRODUCT_HARD_LIMIT_BYTES} estimated root-index bytes. Individual cells, row shards and the encoded root are checked before writes.`
                    : undefined,
        };
    }
    if (rowCount >= database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.import.inlineWarningRowThreshold) {
        warnings.push(`${source} has ${rowCount} rows; inline import is close to the queued import threshold.`);
    }
    if (columnCount >=
        database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.import.inlineWarningColumnThreshold) {
        warnings.push(`${source} has ${columnCount} columns; inline import is close to the queued import threshold.`);
    }
    if (estimatedTotalBytes >=
        exports.DATABASE_IMPORT_INLINE_ESTIMATED_BYTE_WARNING_THRESHOLD) {
        warnings.push(`${source} is estimated at ${estimatedTotalBytes} bytes; inline import is close to the queued import threshold.`);
    }
    if (rowCount === 0 || columnCount === 0) {
        return {
            source,
            rowCount,
            columnCount,
            effectiveColumnCount,
            cellCount,
            estimatedCellBytes,
            estimatedTotalBytes,
            estimatedShardCount,
            allowedAction: 'blocked-empty',
            warnings,
            blockReason: `${source} has no importable rows or columns.`,
        };
    }
    const shapeExceedsInlineImport = rowCount > database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.import.inlineBlockRowThreshold ||
        columnCount > database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.import.inlineBlockColumnThreshold;
    const bytesExceedInlineImport = estimatedTotalBytes > exports.DATABASE_IMPORT_INLINE_ESTIMATED_BYTE_HARD_LIMIT;
    if (exceedsDatabaseLimits) {
        return {
            source,
            rowCount,
            columnCount,
            effectiveColumnCount,
            cellCount,
            estimatedCellBytes,
            estimatedTotalBytes,
            estimatedShardCount,
            allowedAction: 'blocked-too-large',
            warnings,
            blockReason: databaseLimitsReason,
        };
    }
    if (shapeExceedsInlineImport || bytesExceedInlineImport) {
        const reason = shapeExceedsInlineImport
            ? `${source} has ${rowCount} rows and ${columnCount} columns; inline import is limited to ${database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.import.inlineBlockRowThreshold} rows and ${database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.import.inlineBlockColumnThreshold} columns.`
            : `${source} is estimated at ${estimatedTotalBytes} bytes; inline import is limited to ${exports.DATABASE_IMPORT_INLINE_ESTIMATED_BYTE_HARD_LIMIT} estimated bytes.`;
        return {
            source,
            rowCount,
            columnCount,
            effectiveColumnCount,
            cellCount,
            estimatedCellBytes,
            estimatedTotalBytes,
            estimatedShardCount,
            allowedAction: 'queued-sharded-import',
            warnings,
            blockReason: `${reason} Queued sharded import is required.`,
        };
    }
    return {
        source,
        rowCount,
        columnCount,
        effectiveColumnCount,
        cellCount,
        estimatedCellBytes,
        estimatedTotalBytes,
        estimatedShardCount,
        allowedAction: 'inline-sharded-import',
        warnings,
    };
}
function assertDatabaseImportPreflightAllowsInlineShardedMutation(estimate) {
    if (estimate.allowedAction !== 'inline-sharded-import') {
        throw new RangeError(estimate.blockReason ?? `${estimate.source} cannot be imported inline.`);
    }
}
function assertDatabaseImportPreflightAllowsShardedMutation(estimate) {
    if (estimate.allowedAction !== 'inline-sharded-import' &&
        estimate.allowedAction !== 'queued-sharded-import') {
        throw new RangeError(estimate.blockReason ??
            `${estimate.source} cannot be imported by the current sharded import path.`);
    }
}
function isValidDatabaseBlockId(value) {
    return typeof value === 'string' && value.length > 0 && !value.includes('$');
}
function assertNonEmptyDocumentId(value, label) {
    if (!value) {
        throw new Error(`${label} must be a non-empty document id`);
    }
}
/**
 * Value keys are fields of the stored entry. An already normalized entry lists
 * them as `valueKeys`; reading that list too keeps normalizing idempotent.
 */
function readShardValueKeys(shard) {
    const keys = (0, database_manifest_fields_1.isMapLike)(shard) && typeof shard.keys === 'function'
        ? [...shard.keys()]
        : (0, database_manifest_fields_1.isRecord)(shard) && !(0, database_manifest_fields_1.isMapLike)(shard)
            ? [
                ...Object.keys(shard),
                ...(Array.isArray(shard.valueKeys) ? shard.valueKeys : []),
            ]
            : [];
    const valueKeys = [
        ...new Set(keys.filter((key) => typeof key === 'string' && (0, database_value_summary_1.isDatabaseShardValueKey)(key))),
    ];
    return valueKeys.length ? valueKeys.sort() : undefined;
}
/**
 * Write clocks are stored as one field per client of the entry. An already
 * normalized entry lists them as `rowWriteClocks`, like the fingerprints.
 */
function readShardRowWriteClocks(shard) {
    const nested = (0, database_manifest_fields_1.readManifestField)(shard, 'rowWriteClocks');
    const entries = nested === undefined
        ? storedFields(shard)
        : (0, database_manifest_fields_1.isRecord)(nested) && !(0, database_manifest_fields_1.isMapLike)(nested)
            ? Object.entries(nested).map(([clientId, clock]) => [
                database_row_fingerprint_1.DATABASE_ROW_WRITE_CLOCK_KEY_PREFIX + clientId,
                clock,
            ])
            : [[database_row_fingerprint_1.DATABASE_ROW_WRITE_CLOCK_KEY_PREFIX, nested]];
    const clocks = [];
    for (const [key, value] of entries) {
        if (typeof key !== 'string' ||
            !key.startsWith(database_row_fingerprint_1.DATABASE_ROW_WRITE_CLOCK_KEY_PREFIX))
            continue;
        const clientId = key.slice(database_row_fingerprint_1.DATABASE_ROW_WRITE_CLOCK_KEY_PREFIX.length);
        if (!/^\d+$/.test(clientId) ||
            typeof value !== 'number' ||
            !Number.isSafeInteger(value) ||
            value < 0)
            throw new Error(`Database row shard ${(0, database_manifest_fields_1.readStringField)(shard, 'shardId')} has an invalid row write clock`);
        clocks.push([clientId, value]);
    }
    if (!clocks.length)
        return undefined;
    clocks.sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0));
    return Object.fromEntries(clocks);
}
function storedFields(value) {
    if ((0, database_manifest_fields_1.isMapLike)(value) && typeof value.keys === 'function')
        return [...value.keys()].map(key => [key, value.get(key)]);
    return (0, database_manifest_fields_1.isRecord)(value) && !(0, database_manifest_fields_1.isMapLike)(value) ? Object.entries(value) : [];
}
/**
 * Row fingerprints are stored as one field per session of the entry. An
 * already normalized entry lists them as `rowFingerprints`; reading that
 * record keeps normalizing idempotent. A stored entry never nests them,
 * and no entry carries both forms.
 */
function readShardRowFingerprints(shard) {
    const nested = (0, database_manifest_fields_1.readManifestField)(shard, 'rowFingerprints');
    const stored = storedFields(shard).filter(([key]) => typeof key === 'string' &&
        key.startsWith(database_row_fingerprint_1.DATABASE_ROW_FINGERPRINT_KEY_PREFIX));
    if (nested !== undefined &&
        ((0, database_manifest_fields_1.isMapLike)(shard) || stored.length || !(0, database_manifest_fields_1.isRecord)(nested)))
        throw new Error(`Database row shard ${(0, database_manifest_fields_1.readStringField)(shard, 'shardId')} stores row fingerprints outside their session fields`);
    const entries = nested === undefined
        ? stored
        : Object.entries(nested).map(([session, value]) => [
            database_row_fingerprint_1.DATABASE_ROW_FINGERPRINT_KEY_PREFIX + session,
            value,
        ]);
    const fingerprints = [];
    for (const [key, value] of entries) {
        if (typeof key !== 'string' ||
            !key.startsWith(database_row_fingerprint_1.DATABASE_ROW_FINGERPRINT_KEY_PREFIX))
            continue;
        if (!(0, database_row_fingerprint_1.isDatabaseRowFingerprint)(value))
            throw new Error(`Database row shard ${(0, database_manifest_fields_1.readStringField)(shard, 'shardId')} has an invalid row fingerprint`);
        fingerprints.push([
            key.slice(database_row_fingerprint_1.DATABASE_ROW_FINGERPRINT_KEY_PREFIX.length),
            value,
        ]);
    }
    if (!fingerprints.length)
        return undefined;
    fingerprints.sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0));
    return Object.fromEntries(fingerprints);
}
function readShardEntries(value) {
    if ((0, database_manifest_fields_1.readManifestField)(value, 'parts') !== undefined)
        throw new database_storage_errors_1.DatabaseShardDirectoryFormatError('Database shard manifest stores directory parts; read it as a directory head');
    const shards = (0, database_manifest_fields_1.readListField)(value, 'shards');
    if (!shards)
        throw new database_storage_errors_1.DatabaseShardDirectoryFormatError('Database shard manifest has no shard list');
    return shards;
}
function normalizeDatabaseShardManifest(value) {
    if (!value)
        return undefined;
    const manifest = {
        databaseId: (0, database_manifest_fields_1.readStringField)(value, 'databaseId'),
        databaseRootDocId: (0, database_manifest_fields_1.readStringField)(value, 'databaseRootDocId'),
        workspaceId: (0, database_manifest_fields_1.readStringField)(value, 'workspaceId'),
        storageVersion: (0, database_manifest_fields_1.readNumberField)(value, 'storageVersion'),
        targetBytes: (0, database_manifest_fields_1.readNumberField)(value, 'targetBytes'),
        hardLimitBytes: (0, database_manifest_fields_1.readNumberField)(value, 'hardLimitBytes'),
        shards: readShardEntries(value).map(normalizeDatabaseShardManifestEntry),
    };
    assertDatabaseShardManifest(manifest);
    return manifest;
}
/**
 * Canonical form of one row-shard entry, from a plain object or a Y.Map.
 * Entries that crossed the Rust/WASM CRDT codec lose their key order, so
 * entries are compared in this form only.
 */
function normalizeDatabaseShardManifestEntry(shard) {
    return {
        shardId: (0, database_manifest_fields_1.readStringField)(shard, 'shardId'),
        serverDocId: (0, database_manifest_fields_1.readStringField)(shard, 'serverDocId'),
        ...(() => {
            const rowFingerprints = readShardRowFingerprints(shard);
            return rowFingerprints ? { rowFingerprints } : {};
        })(),
        ...(() => {
            const rowWriteClocks = readShardRowWriteClocks(shard);
            return rowWriteClocks ? { rowWriteClocks } : {};
        })(),
        ...((0, database_manifest_fields_1.readManifestField)(shard, 'rowFingerprintSeq') === undefined
            ? {}
            : { rowFingerprintSeq: (0, database_manifest_fields_1.readNumberField)(shard, 'rowFingerprintSeq') }),
        firstRowId: (0, database_manifest_fields_1.readOptionalStringField)(shard, 'firstRowId'),
        lastRowId: (0, database_manifest_fields_1.readOptionalStringField)(shard, 'lastRowId'),
        rowCount: (0, database_manifest_fields_1.readNumberField)(shard, 'rowCount'),
        encodedBytes: (0, database_manifest_fields_1.readNumberField)(shard, 'encodedBytes'),
        status: (0, database_manifest_fields_1.readStringField)(shard, 'status'),
        ...(() => {
            const valueKeys = readShardValueKeys(shard);
            return valueKeys ? { valueKeys } : {};
        })(),
    };
}
function planDatabaseShardRowWindow(manifest, request) {
    assertDatabaseShardManifest(manifest);
    (0, database_manifest_fields_1.assertNonNegativeInteger)(request.offset, 'Database shard window offset');
    (0, database_manifest_fields_1.assertNonNegativeInteger)(request.limit, 'Database shard window limit');
    if (request.limit === 0) {
        throw new RangeError('Database shard window limit must be positive');
    }
    const totalCount = manifest.shards.reduce((sum, shard) => sum + shard.rowCount, 0);
    const windowEnd = Math.min(totalCount, request.offset + request.limit);
    const segments = [];
    let shardStart = 0;
    for (const [shardIndex, shard] of manifest.shards.entries()) {
        const shardEnd = shardStart + shard.rowCount;
        const segmentStart = Math.max(request.offset, shardStart);
        const segmentEnd = Math.min(windowEnd, shardEnd);
        if (segmentStart < segmentEnd) {
            segments.push({
                shard,
                shardIndex,
                globalOffset: segmentStart,
                rowOffset: segmentStart - shardStart,
                rowLimit: segmentEnd - segmentStart,
            });
        }
        shardStart = shardEnd;
        if (shardStart >= windowEnd)
            break;
    }
    return {
        offset: request.offset,
        limit: request.limit,
        totalCount,
        hasMore: windowEnd < totalCount,
        segments,
    };
}
function assertDatabaseRowShardBytesWithinLimits({ source, encodedBytes, hardLimitBytes = exports.DATABASE_ROW_SHARD_HARD_LIMIT_BYTES, }) {
    (0, database_manifest_fields_1.assertNonNegativeInteger)(encodedBytes, 'Database row-shard encoded bytes');
    (0, database_manifest_fields_1.assertNonNegativeInteger)(hardLimitBytes, 'Database row-shard hard limit');
    if (hardLimitBytes === 0) {
        throw new RangeError('Database row-shard hard limit must be positive');
    }
    if (encodedBytes <= hardLimitBytes)
        return;
    throw new RangeError(`${source} has ${encodedBytes} encoded bytes; row-shard hard limit is ${hardLimitBytes} bytes`);
}
function createShardedDatabaseIdentityProps({ databaseId: providedDatabaseId, databaseRootDocId: providedDatabaseRootDocId, generateDatabaseId, workspaceId, }) {
    const databaseId = providedDatabaseId ?? generateDatabaseId?.();
    if (!databaseId) {
        throw new Error('createShardedDatabaseIdentityProps requires databaseId or generateDatabaseId');
    }
    const databaseRootDocId = providedDatabaseRootDocId ??
        (0, database_document_identity_1.createServerDatabaseRootDocId)({ workspaceId, databaseId });
    return {
        databaseId,
        databaseRootDocId,
        databaseStorageVersion: database_document_scheme_1.DATABASE_STORAGE_VERSION,
        // A new database has no shard yet, so its head names no part.
        databaseShardManifest: (0, database_shard_directory_parts_1.splitDatabaseShardDirectory)(createDatabaseShardManifest({
            databaseId,
            workspaceId,
            databaseRootDocId,
        })).head,
    };
}
function createDatabaseReferenceProps({ databaseId: providedDatabaseId, databaseRootDocId: providedDatabaseRootDocId, generateDatabaseId, workspaceId, }) {
    const databaseId = providedDatabaseId ?? generateDatabaseId?.();
    if (!databaseId) {
        throw new Error('createDatabaseReferenceProps requires databaseId or generateDatabaseId');
    }
    return {
        databaseId,
        databaseRootDocId: providedDatabaseRootDocId ??
            (0, database_document_identity_1.createServerDatabaseRootDocId)({ workspaceId, databaseId }),
        databaseStorageVersion: database_document_scheme_1.DATABASE_STORAGE_VERSION,
    };
}
function writeSerializedShardedDatabaseIdentity(target, input) {
    const identity = createShardedDatabaseIdentityProps(input);
    target.set('prop:databaseId', identity.databaseId);
    target.set('prop:databaseRootDocId', identity.databaseRootDocId);
    target.set('prop:databaseStorageVersion', identity.databaseStorageVersion);
    target.set(database_shard_manifest_crdt_1.DATABASE_SHARD_MANIFEST_PROP, (0, database_shard_directory_parts_1.databaseShardDirectoryHeadToYMap)(identity.databaseShardManifest));
    return identity;
}
function writeSerializedDatabaseReference(target, input) {
    const identity = createDatabaseReferenceProps(input);
    target.set('prop:databaseId', identity.databaseId);
    target.set('prop:databaseRootDocId', identity.databaseRootDocId);
    target.set('prop:databaseStorageVersion', identity.databaseStorageVersion);
    return identity;
}
function resolveDatabaseIdentity(model) {
    const databaseId = model.props.databaseId;
    const storageVersion = model.props.databaseStorageVersion;
    if (!databaseId || storageVersion === undefined) {
        return {
            status: 'missing-identity',
            blockId: model.id,
            missingDatabaseId: !databaseId,
            missingStorageVersion: storageVersion === undefined,
        };
    }
    if (storageVersion !== database_document_scheme_1.DATABASE_STORAGE_VERSION) {
        return {
            status: 'unsupported-version',
            databaseId,
            storageVersion,
            currentStorageVersion: database_document_scheme_1.DATABASE_STORAGE_VERSION,
        };
    }
    return {
        status: 'ready',
        databaseId,
        storageVersion,
    };
}
function assertDatabaseIdentity(model) {
    const resolved = resolveDatabaseIdentity(model);
    if (resolved.status === 'ready') {
        return resolved;
    }
    if (resolved.status === 'missing-identity') {
        throw new Error(`Database block ${resolved.blockId} is missing database identity`);
    }
    throw new database_storage_errors_1.UnsupportedDatabaseStorageVersionError(`Database ${resolved.databaseId}`, resolved.storageVersion, resolved.currentStorageVersion);
}
function createDatabaseShardManifestEntry({ databaseId, workspaceId, shardId, rowFingerprints, rowWriteClocks, rowFingerprintSeq, firstRowId, lastRowId, rowCount, encodedBytes, hardLimitBytes, status, valueKeys, }) {
    (0, database_document_identity_1.assertNonEmptyIdentifier)(databaseId, 'Database id');
    (0, database_document_identity_1.assertNonEmptyIdentifier)(shardId, 'Database row-shard id');
    (0, database_manifest_fields_1.assertNonNegativeInteger)(rowCount, 'Database row-shard row count');
    assertDatabaseRowShardBytesWithinLimits({
        source: `Database row shard ${shardId}`,
        encodedBytes,
        hardLimitBytes,
    });
    return {
        shardId,
        serverDocId: (0, database_document_identity_1.createServerDatabaseRowShardDocId)({
            workspaceId,
            databaseId,
            shardId,
        }),
        ...(rowFingerprints && Object.keys(rowFingerprints).length
            ? { rowFingerprints: { ...rowFingerprints } }
            : {}),
        ...(rowWriteClocks && Object.keys(rowWriteClocks).length
            ? { rowWriteClocks: { ...rowWriteClocks } }
            : {}),
        ...(rowFingerprintSeq === undefined ? {} : { rowFingerprintSeq }),
        firstRowId,
        lastRowId,
        rowCount,
        encodedBytes,
        status,
        ...(valueKeys?.length ? { valueKeys: [...valueKeys].sort() } : {}),
    };
}
function createDatabaseShardManifest({ databaseId, databaseRootDocId, workspaceId, targetBytes = exports.DATABASE_ROW_SHARD_TARGET_BYTES, hardLimitBytes = exports.DATABASE_ROW_SHARD_HARD_LIMIT_BYTES, nextShardIndex, shards = [], }) {
    const manifest = {
        databaseId,
        databaseRootDocId,
        workspaceId,
        storageVersion: database_document_scheme_1.DATABASE_STORAGE_VERSION,
        targetBytes,
        hardLimitBytes,
        ...(nextShardIndex === undefined ? {} : { nextShardIndex }),
        shards: [...shards],
    };
    assertDatabaseShardManifest(manifest);
    return manifest;
}
function assertDatabaseShardManifest(manifest) {
    (0, database_document_identity_1.assertNonEmptyIdentifier)(manifest.databaseId, 'Database id');
    assertNonEmptyDocumentId(manifest.databaseRootDocId, 'Database root document id');
    (0, database_document_identity_1.assertNonEmptyIdentifier)(manifest.workspaceId, 'Workspace id');
    (0, database_manifest_fields_1.assertNonNegativeInteger)(manifest.targetBytes, 'Database row-shard target');
    (0, database_manifest_fields_1.assertNonNegativeInteger)(manifest.hardLimitBytes, 'Database row-shard hard limit');
    if (manifest.nextShardIndex !== undefined)
        (0, database_manifest_fields_1.assertNonNegativeInteger)(manifest.nextShardIndex, 'Database next row-shard index');
    if (manifest.storageVersion !== database_document_scheme_1.DATABASE_STORAGE_VERSION) {
        throw new database_storage_errors_1.UnsupportedDatabaseStorageVersionError('Database shard manifest', manifest.storageVersion, database_document_scheme_1.DATABASE_STORAGE_VERSION);
    }
    if (manifest.targetBytes === 0 || manifest.hardLimitBytes === 0) {
        throw new RangeError('Database row-shard byte budgets must be positive');
    }
    if (manifest.targetBytes > manifest.hardLimitBytes) {
        throw new RangeError('Database row-shard target bytes must not exceed hard limit bytes');
    }
    const shardIds = new Set();
    for (const shard of manifest.shards) {
        (0, database_document_identity_1.assertNonEmptyIdentifier)(shard.shardId, 'Database row-shard id');
        if (shardIds.has(shard.shardId)) {
            throw new Error(`Duplicate database row-shard id ${shard.shardId}`);
        }
        shardIds.add(shard.shardId);
        (0, database_manifest_fields_1.assertNonNegativeInteger)(shard.rowCount, 'Database row-shard row count');
        for (const [session, fingerprint] of Object.entries(shard.rowFingerprints ?? {})) {
            if (!session || !(0, database_row_fingerprint_1.isDatabaseRowFingerprint)(fingerprint)) {
                throw new Error(`Database row shard ${shard.shardId} has an invalid row fingerprint`);
            }
        }
        for (const [clientId, clock] of Object.entries(shard.rowWriteClocks ?? {})) {
            if (!/^\d+$/.test(clientId) || !Number.isSafeInteger(clock) || clock < 0)
                throw new Error(`Database row shard ${shard.shardId} has an invalid row write clock`);
        }
        if (shard.rowFingerprintSeq !== undefined)
            (0, database_manifest_fields_1.assertNonNegativeInteger)(shard.rowFingerprintSeq, 'Database row-shard fingerprint sequence');
        assertDatabaseRowShardBytesWithinLimits({
            source: `Database row shard ${shard.shardId}`,
            encodedBytes: shard.encodedBytes,
            hardLimitBytes: manifest.hardLimitBytes,
        });
        const parsed = (0, database_document_identity_1.parseServerDatabaseRowShardDocId)(shard.serverDocId, manifest.workspaceId);
        if (!parsed ||
            parsed.databaseId !== manifest.databaseId ||
            parsed.shardId !== shard.shardId) {
            throw new Error(`Database row shard ${shard.shardId} has invalid server doc id`);
        }
    }
}
/**
 * {@link databaseShardMayContainRow} for a row hashed once
 * ({@link databaseRowFingerprintProbe}), for readers that ask many shards.
 */
function databaseShardMayContainProbe(shard, probe) {
    if (!shard.rowFingerprints) {
        if (shard.rowCount === 0)
            return false;
        throw new database_storage_errors_1.DatabaseShardRowFingerprintsMissingError(shard.shardId);
    }
    return (0, database_row_fingerprint_1.databaseRowFingerprintsMayContain)(Object.values(shard.rowFingerprints), probe);
}
/**
 * False only when the shard never received the row. A shard that never held
 * a row has no fingerprints; one that holds rows without them is corrupt
 * ({@link DatabaseShardRowFingerprintsMissingError}).
 */
function databaseShardMayContainRow(shard, rowId) {
    return databaseShardMayContainProbe(shard, (0, database_row_fingerprint_1.databaseRowFingerprintProbe)(rowId));
}
/**
 * The shards whose fingerprints may hold the row, asked with one hash of the
 * row id. A false positive only costs loading one more shard; callers confirm
 * the row in the loaded shards.
 */
function selectDatabaseShardsMayContainRow(shards, rowId) {
    const probe = (0, database_row_fingerprint_1.databaseRowFingerprintProbe)(rowId);
    return shards.filter(shard => databaseShardMayContainProbe(shard, probe));
}
/**
 * Whether a shard's fingerprints may hold the row, asked with one hash of the
 * row id; stops at the first shard that may, like asking each shard in turn.
 */
function databaseShardsMayContainRow(shards, rowId) {
    const probe = (0, database_row_fingerprint_1.databaseRowFingerprintProbe)(rowId);
    return shards.some(shard => databaseShardMayContainProbe(shard, probe));
}
/** The shards whose fingerprints may hold one of the rows, each row hashed once. */
function selectDatabaseShardsMayContainRows(shards, rowIds) {
    const probes = [...new Set(rowIds)].map(database_row_fingerprint_1.databaseRowFingerprintProbe);
    return shards.filter(shard => probes.some(probe => databaseShardMayContainProbe(shard, probe)));
}
/**
 * Shards whose fingerprints may hold one of the rows. A false positive only
 * costs loading one more shard; callers confirm rows in the loaded shards.
 */
function selectDatabaseRowShardsByIds(manifest, rowIds) {
    return selectDatabaseShardsMayContainRows(manifest.shards, rowIds).map(shard => shard.shardId);
}
__exportStar(require("./database-ai-filter"), exports);
__exportStar(require("./database-bulk"), exports);
var database_rollup_1 = require("./database-rollup");
Object.defineProperty(exports, "computeRollupValue", { enumerable: true, get: function () { return database_rollup_1.computeRollupValue; } });
__exportStar(require("./database-root-provisioning"), exports);
__exportStar(require("./database-row-fingerprint"), exports);
__exportStar(require("./database-row-shard-read"), exports);
__exportStar(require("./database-row-window"), exports);
__exportStar(require("./database-shard-directory"), exports);
__exportStar(require("./database-shard-directory-parts"), exports);
__exportStar(require("./database-shard-directory-write"), exports);
__exportStar(require("./database-shard-manifest-crdt"), exports);
__exportStar(require("./database-storage-errors"), exports);
__exportStar(require("./database-value-summary"), exports);
__exportStar(require("./fractional-indexing"), exports);
__exportStar(require("./page-canvas"), exports);
__exportStar(require("./page-connector-ends"), exports);
__exportStar(require("./page-document-maps"), exports);
__exportStar(require("./page-document-projection"), exports);
__exportStar(require("./page-document-split"), exports);
__exportStar(require("./page-document-upgrade"), exports);
__exportStar(require("./page-format-chain"), exports);
__exportStar(require("./page-large-data-policy"), exports);
__exportStar(require("./page-layer-index"), exports);
__exportStar(require("./page-layer-upgrade"), exports);
__exportStar(require("./page-lookup"), exports);
var page_part_candidates_1 = require("./page-part-candidates");
Object.defineProperty(exports, "pagePartsMayHoldId", { enumerable: true, get: function () { return page_part_candidates_1.pagePartsMayHoldId; } });
__exportStar(require("./page-part-directory"), exports);
__exportStar(require("./page-part-planner"), exports);
__exportStar(require("./page-part-rect"), exports);
__exportStar(require("./page-part-summary"), exports);
__exportStar(require("./page-read-source"), exports);
var page_structure_ancestors_1 = require("./page-structure-ancestors");
Object.defineProperty(exports, "pageStructureAncestors", { enumerable: true, get: function () { return page_structure_ancestors_1.pageStructureAncestors; } });
__exportStar(require("./page-structure-entry"), exports);
__exportStar(require("./page-structure-index"), exports);
__exportStar(require("./page-structure-parts-upgrade"), exports);
__exportStar(require("./page-structure-prune"), exports);
__exportStar(require("./page-structure-remap"), exports);
__exportStar(require("./page-structure-tree"), exports);
__exportStar(require("./page-structure-upgrade"), exports);
__exportStar(require("./page-structure-writer"), exports);
__exportStar(require("./page-subdocs"), exports);
__exportStar(require("./writer-shard-id"), exports);
__exportStar(require("./zoned-wall-time"), exports);
